var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "im-option-group" }, [
    _c(
      "div",
      {
        staticClass: "title",
        on: {
          click: function ($event) {
            $event.stopPropagation()
          },
        },
      },
      [_vm._v(_vm._s(_vm.label))]
    ),
    _vm._v(" "),
    _c("div", { staticClass: "group" }, [_vm._t("default")], 2),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }